var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_WHATSAPP_NOTIFICATION_CHARGES_REQUEST, updateWhatsappNotificationChargesSuccess, updateWhatsappNotificationChargesFailure, } from "../../actions";
import APIIN from "../../../utils/APIIN";
// API call for updating WhatsApp Notification Charges
const onUpdateWhatsappNotificationCharges = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post(`rms/admin/vas/wa?tenantId=${action.payload.tenantId}&countryCode=${action.payload.countryCode}&activation=${action.payload.activation}`, {})
                .then((data) => resolve(data))
                .catch((error) => reject(error));
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
// Worker saga
function* updateWhatsappNotificationChargesWorker(action) {
    try {
        const data = yield call(onUpdateWhatsappNotificationCharges, action);
        yield put(updateWhatsappNotificationChargesSuccess(data));
    }
    catch (error) {
        yield put(updateWhatsappNotificationChargesFailure(error));
    }
}
// Watcher saga
export function* watchUpdateWhatsappNotificationChargesData() {
    yield takeLatest(UPDATE_WHATSAPP_NOTIFICATION_CHARGES_REQUEST, updateWhatsappNotificationChargesWorker);
}
